export default __webpack_public_path__ + "static/media/water.4e95e0bd.png";